import { GET_JOURNALISTS } from '../constants/journalists';

export default (state = [], action) => {
  switch (action.type) {
    case GET_JOURNALISTS:
      return action.payload && action.payload.length > 0
        ? [...state, ...action.payload]
        : [...state];

    default:
      return state;
  }
};
